import type { InjectionKey, Ref } from "vue";

export const SCROLL_TARGET_INJECTION_KEY: InjectionKey<
  Ref<HTMLElement | undefined>
> = Symbol("SCROLL_TARGET_INJECTION_KEY");
